/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Verifying_TextInputs */

const en_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait while we verify your subscription...`)
};

const fr_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez patienter pendant la verification de votre abonnement...`)
};

const de_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte warten Sie, während wir Ihr Abonnement überprüfen...`)
};

const it_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attendi mentre verifichiamo la tua iscrizione...`)
};

const ru_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, подождите, пока мы проверим вашу подписку...`)
};

const es_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor espere mientras verificamos su suscripción...`)
};

const zh_cn2_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请稍候，我们正在验证您的订阅信息……`)
};

const ja_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションを確認中です。しばらくお待ちください...`)
};

const hi_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया प्रतीक्षा करें जब तक हम आपकी सदस्यता की पुष्टि नहीं कर लेते...`)
};

const pt_pt2_creator_checkout_verifying_text = /** @type {(inputs: Creator_Checkout_Verifying_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguarde enquanto verificamos sua assinatura...`)
};

/**
* | output |
* | --- |
* | "Please wait while we verify your subscription..." |
*
* @param {Creator_Checkout_Verifying_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verifying_text = /** @type {((inputs?: Creator_Checkout_Verifying_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verifying_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_checkout_verifying_text(inputs)
	if (locale === "de") return de_creator_checkout_verifying_text(inputs)
	if (locale === "it") return it_creator_checkout_verifying_text(inputs)
	if (locale === "ru") return ru_creator_checkout_verifying_text(inputs)
	if (locale === "es") return es_creator_checkout_verifying_text(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_checkout_verifying_text(inputs)
	if (locale === "ja") return ja_creator_checkout_verifying_text(inputs)
	if (locale === "hi") return hi_creator_checkout_verifying_text(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_checkout_verifying_text(inputs)
	return en_creator_checkout_verifying_text(inputs)
});